import { AUTH_MODES, getAuthMode } from '@xstudios/xapp-auth/config/authMode'
import {
  setAuthPolicyHooks as configureAuthPolicyHooks,
  resetAuthPolicyHooks,
} from '@xstudios/xapp-auth/services/authPolicyHooks'
import * as fastApiTokenAuthService from '@xstudios/xapp-auth/services/fastApiTokenAuthService'
import * as googleJwtAuthService from '@xstudios/xapp-auth/services/googleJwtAuthService'

import { allauthClient, apiClient } from '../shared/httpClients'

const mode = getAuthMode()

const allauthFacade = {
  api: apiClient,
  authApi: allauthClient,
  authTokenApi: allauthClient,
  isTokenExpired: () => false,
  login() {
    throw new Error(
      'Use allauthSessionAuthService.loginWithPassword in allauth mode.'
    )
  },
  logout() {
    throw new Error(
      'Use allauthSessionAuthService.logoutSession in allauth mode.'
    )
  },
  refresh() {
    throw new Error('Refresh token flow is not available in allauth mode.')
  },
}

const service =
  mode === AUTH_MODES.ALLAUTH
    ? allauthFacade
    : mode === AUTH_MODES.FASTAPI
      ? fastApiTokenAuthService
      : googleJwtAuthService

export const api = service.api
export const authApi = service.authApi ?? service.api
export const authTokenApi = service.authTokenApi ?? service.api
export const isTokenExpired = service.isTokenExpired ?? (() => false)
export const login = service.login
export const logout = service.logout
export const refresh = service.refresh
export const setAuthPolicyHooks = configureAuthPolicyHooks
export const clearAuthPolicyHooks = resetAuthPolicyHooks
